import { useMemo } from "react";
import routeConfige from "../../app/providers/router/config";


const useAppRoutes = (props) => {
    const { includeIcons = false} = props;
  
    return useMemo(() => {
        return Object.values(routeConfige)
        
        .filter(route => !route.adminOnly)
        .map(route => ({
            path:route.path,
            navlink: route.navlink,
            img: includeIcons ? route.img : null
        }));
    }, [ includeIcons])
}

export default useAppRoutes;